// extracted by mini-css-extract-plugin
module.exports = {"agreement":"RegistrationSetPassword_agreement__1jTMD"};